/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, StyledModal, ModalActions, ButtonGroup, Text } from 'sarsaparilla';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
};

export default class UnauthorizedErrorModal extends React.Component {
    render() {
        return (
            <StyledModal
                shouldShowCloseButton={false}
                shouldActionsStickInMobile
                size="md"
                isOpen={this.props.isOpen}
                heading="No Commercial Authorization"
                onRequestClose={this.props.closeModal}
            >
                <Text>
                    {' '}
                    You are not authorized to make commercial reservations at this
                    location, please contact the facility for more information.
                </Text>

                <ModalActions>
                    <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                        <Button onClick={this.props.closeModal} appearance="tertiary">
                            Close
                        </Button>
                    </ButtonGroup>
                </ModalActions>
            </StyledModal>
        );
    }
}

UnauthorizedErrorModal.propTypes = propTypes;
